import { Language } from '@/siteBuilder/locale'
import { Entry } from 'contentful'
/**
 * Function to extract  language from contentful locale
 * @param  {Entry<unknown>} entry contentful entry
 *
 * @returns Language
 *
 * @example
 * // returns "en"
 * getLangFromContentfulLocale('en-CA-AB')
 *
 * @example
 * // returns "fr"
 * getLangFromContentfulLocale('fr-CA')
 */
export const getLangFromContentfulLocale = (entry: Entry<unknown>) =>
  (entry.sys?.locale?.split('-')[0] || 'en') as Language
